import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

export default class extends Controller {
  connect() {
    this.modal = new Modal(this.element);
    this.modal.show(); // show modal when controller connects
  }

  hide() {
    // remove focus from anything in the modal to prevent
    // assistive tech warnings in the console
    if (document.activeElement) {
      document.activeElement.blur();
    }

    this.modal.hide();
  }

  disconnect() {
    this.modal.dispose();
  }
}
